module.exports = __webpack_public_path__ + "media/application/images/svgs/blob-1-beb332fc56d179d2007d807576d78dbd.svg";